import {RestResource} from '../rest'
import {EQUIPMENT_IN_OUT_SERVER} from '../server'
import {athubAxios} from '../../util'

const equipmentInOut = new RestResource({server: EQUIPMENT_IN_OUT_SERVER, resource: 'equipmentinout'});

equipmentInOut.exportExcel = (equinoutuid, type) => {
    let url = `${EQUIPMENT_IN_OUT_SERVER}/equipmentinout/excel/${equinoutuid}/type/${type}/`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url, {responseType: 'blob'}).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default equipmentInOut;